import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const StoreCheckPages = {
  list: 'ListStoreCheck',
  add: 'AddStoreCheck',
  edit: 'EditStoreCheck',
}

const { t } = i18n.global

const title = t('pages.listStoreCheck')
const path = '/store-check'
const breadcrumb = [{ title, path }]

const Add: RouteRecordRaw = {
  path: 'add',
  name: StoreCheckPages.add,
  component: () => import('@/pages/mainPageWithRoute/store-check/AddStoreCheckPage.vue'),
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: StoreCheckPages.edit,
  component: () => import('@/pages/mainPageWithRoute/store-check/EditStoreCheckPage.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: StoreCheckPages.list,
  component: () => import('@/pages/mainPageWithRoute/store-check/ListStoreCheckPage.vue'),
  meta: { title, requiresAuth: true },
}

export const StoreChecks: RouteRecordRaw = {
  path,
  name: 'StoreChecks',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Edit, Add],
}
